import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() { }

  //Set local storage item
  SetItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  //Get local storage item
  GetItem(key: string) {
    let value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
    return null;
  }

  RemoveItem(key: string) {
    localStorage.removeItem(key);
  }

}
